<template>
  <div class="box-b">
    <div :id="chartId" class="allnav"></div>
  </div>
</template>
<script>
import echarts from "@/js/charts.js";
export default {
  props: {
    chartId: {
      type: String,
      default: "",
    },
    area:{
      type:Array
    },
    seriesData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch:{
    area(val){
      if(val[1]){
        this.getData()
      }
    }
  },
  data() {
    return {
      seriesDataPie1:[],
      PieChart1: null,
    };
  },
  beforeDestroy() {
    // 清理工作 避免内存泄漏
    // 销毁监听事件
    window.removeEventListener("resize", this.resizeHandler);
    //this.disposeChart();
  },
  created() {
    
  },
  mounted() {
    console.log(this.chartId, "饼图mounted");
    this.creatChart();
    window.addEventListener("resize", this.resizeHandler);
    if(this.area[1]){
        this.getData()
      }
  },
  methods: {
    getData(){
      this.$axios.get(`/screen/screen/city/pieChart?province=${this.area[0]}&city=${this.area[1]}`).then(res=>{
        this.seriesDataPie1= res.data.data.map(item=>{
          return{
            name:item.rubbishName,
            value:item.num
          }
        })
        this.PieChart1.setOption({
          series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            labelLine: {
              show: true,
            },
            data: this.seriesDataPie1,
          },
        ],
        })
      })
    },
    // 环形饼图配置
    creatChart() {
      this.PieChart1 = echarts.init(
        document.getElementById(this.chartId),
        null,
        {
          renderer: "svg",
        }
      );
      this.PieChart1.setOption({
        tooltip: {
          trigger: "item",
          // formatter: "{b}：{c}",
          showContent: true,
        },
        grid: {
          top: "20%",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            labelLine: {
              show: true,
            },
            data: this.seriesDataPie1,
          },
        ],
      },);
    },

    resizeHandler() {
      this.PieChart1.resize();
    },

    // 销毁 Echarts 实例
    disposeChart() {
      this.PieChart1.dispose();
    },
  },
};
</script>
<style lang="scss" scoped>
.box-b {
  width: 100%;
  height: 260px;
  position: relative;
  left: 0;
  bottom: 0;

  .tab {
    width: 100%;
    position: absolute;
    top: 10px;
    text-align: center;
    z-index: 2;

    span {
      display: inline-block;
      width: 51px;
      height: 23px;
      border: 1px solid #0bc4e9;
      font-size: 14px;
      line-height: 23px;
      color: #fff;
      cursor: pointer;
      margin: 5px;
      border-radius: 6px;
    }
  }
}
</style>